import "./App.css";
import ReactDOM from "react-dom";
import { Routes, Route, useLocation } from "react-router-dom";
import React, { createContext, useEffect, useState, useRef } from "react";
import DashBoard from "./components/dashboard/DashBoard";
import VisitorDashboard from "./components/dashboard/VisitorDashboard";
import FuturisticDashboard from "./components/dashboard/futuristic/FuturisticDashboard";
import TopBar from "./components/topbar/TopBar";
import Visitorlist from "./components/visitor/visitorlist";
import Vehicle from "./components/vehicle/vehiclelist.js";
import Courier from "./components/courier/courierlist.js";
import Courierview from "./components/courier/courierview.js";
import Vehicleview from "./components/vehicle/vehicleview.js";
import Vehicleadd from "./components/vehicle/vehicleadd.js";
import Courieradd from "./components/courier/courieradd.js";
import Visitoradd from "./components/visitor/visitorlist.js";
import Report from "./components/report/report.js";
import { VisitorCreate } from "./components/visitor/visitor-create/visitor-create";
import VisitorView from "./components/visitor/visitor-view/visitor_view_1.js";
import { VehicleCreate } from "./components/vehicle/vehicle-create/vehicle-create.js";
import VehicleView from "./components/vehicle/vehicle-view/vehicle_view.js";
import { CourierCreate } from "./components/courier/courier-create/courier-create.js";
import CourierView from "./components/courier/courier-view/courier_view.js";
import { WhatsAppTemplateCreate } from "./components/whatsapp-template/whatsapp-template-create.js";
import { TemplateCreate } from "./components/whatsapp-template/template-create.js";
import { TabProvider } from "./components/common/context/tabcontext.js";
import SideBar from "./components/sidebar/sidebar.js";
import Vehiclemaster from "./components/masters/vehiclemaster/vehiclemasterlist.js";
import Gatemaster from "./components/masters/gatemaster/gatemasterlist.js";
import Purposeofvisit from "./components/masters/purposeofvisit/purposeofvisitlist.js";
import Checklist from "./components/masters/checklist/checklistlist.js";
import Template from "./components/masters/template/templatelist.js";
import Whatsapptemplate from "./components/masters/whatsapptemplate/whatsapptemplatelist.js";
import AlertconfigurationAdd from "./components/masters/alertconfiguration/alertconfigurationcreate.js";
import Alertconfiguration from "./components/masters/alertconfiguration/alertconfigurationlist.js";
import Registerfieldsadd from "./components/masters/registerfields/registerfieldadd.js";
import Registerfields from "./components/masters/registerfields/registerfieldslist.js";
import CustomerList from "./components/masters/customer/customerlist.js";
import TransporterList from "./components/masters/transporter/transporterlist.js";
import VendorList from "./components/masters/vendor/vendorlist.js";
import Product from "./components/masters/producttype/productlist.js";
import Nfc from "./components/masters/nfc/nfc-list.jsx";
import NfcView from "./components/masters/nfc/nfc-view.jsx";

import { TemplateAdd } from "./components/masters/template/template-add.js";

import { useGlobal } from "./GlobalContext";
import { getCookie } from "./components/getcookie";
import axios from "axios";
import PreLanding from "./pre-landing.js";
import HelpQuestions from "./components/common/help.js";
import { getOrgLogoApi } from "./components/topbar/topbar-api.js";
import PoweredBy from "./components/common/poweredBy.jsx";
import UnAuthorized from "./components/common/unauthorized";

// import { TabProvider } from "./common/context/tabContext";

// Create a context
export const TimeContext = createContext();

function App() {
  const location = useLocation();
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const { rolePermissionList, setRolePermissionList, userType, setUserType, setOrgImage } = useGlobal();
  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await axios.get(adminApiUrl + "validatetoken", {
          headers: { Authorization: getCookie("mawalog") },
        });

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "dock",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie = "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  useEffect(() => {
    getRolePermission();
    getOrgLogo();
  }, []);
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      console.log("orgasss");
      if (response.success === true) {
        setOrgImage(response.image ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getRolePermission = async () => {
    try {
      const response = await axios
        .get(adminApiUrl + "get_role_permission/10", {
          params: {},
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*", // Required for CORS support to work
            Authorization: getCookie("mawalog"),
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              setUserType(response.data.user_type);
              setRolePermissionList(response.data.role_permission ?? []);
              localStorage.setItem("rolePermissionList", JSON.stringify(response.data.role_permission ?? []));
              localStorage.setItem("userType", response.data.user_type ?? "");
            } else {
              setRolePermissionList([]);
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 401) {
              const currentURL = window.location.href;

              const redirectData = {
                redirectPath: currentURL,
                app: "gate",
                ts: Date.now(),
              };

              console.warn("🔐 Saving redirect in window.name:", redirectData);

              // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
              window.name = JSON.stringify(redirectData);
              document.cookie = "mawalog=; path=/; domain=.mawalog.com";
              window.location.href = `${accountsUrl}/login`;
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });

      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
    }
  };
  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);

  if (rolePermissionList.length === 0 && location.pathname !== "/") {
    return <UnAuthorized />;
  }
  return (
    <TabProvider>
      <div
        className="App"
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<PreLanding />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/futuristic" element={<FuturisticDashboard />} />
            <Route path="/visitor-dashboard" element={<VisitorDashboard />} />
            <Route path="/visitors" element={<Visitorlist />} />
            <Route path="/vehicle" element={<Vehicle />} />
            <Route path="/courier" element={<Courier />} />
            <Route path="/courier/add" element={<Courieradd />} />
            <Route path="/visitor/add" element={<Visitoradd />} />
            <Route path="/vehicle/add" element={<Vehicleadd />} />
            <Route path="/courier/view" element={<Courierview />} />
            <Route path="/vehicle/view" element={<Vehicleview />} />
            <Route path="/report" element={<Report />} />
            <Route path="/gatemasters" element={<Gatemaster />} />
            <Route path="/vehiclemasters" element={<Vehiclemaster />} />
            <Route path="/purposeofvisit" element={<Purposeofvisit />} />
            <Route path="/checklist" element={<Checklist />} />
            <Route path="/template" element={<Template />} />
            <Route path="/whatsapptemplate" element={<Whatsapptemplate />} />
            <Route path="/alertconfiguration/add" element={<AlertconfigurationAdd />} />
            <Route path="/alertconfiguration" element={<Alertconfiguration />} />
            <Route path="/registerfields/add" element={<Registerfieldsadd />} />
            <Route path="/registerfields" element={<Registerfields />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/transporters" element={<TransporterList />} />
            <Route path="/vendors" element={<VendorList />} />
            <Route path="/products" element={<Product />} />
            <Route path="/gatetemplate/add" element={<TemplateAdd />} />
            <Route path="/visitor-create" element={<VisitorCreate />} />
            <Route path="/visitor-view" element={<VisitorView />} />
            <Route path="/vehicle-create" element={<VehicleCreate />} />
            <Route path="/vehicle-view" element={<VehicleView />} />
            <Route path="/courier-create" element={<CourierCreate />} />
            <Route path="/courier-view" element={<CourierView />} />
            <Route path="/whatsapp-create" element={<WhatsAppTemplateCreate />} />
            <Route path="/template-create" element={<TemplateCreate />} />
            <Route path="/nfc" element={<Nfc />} />
            <Route path="/nfc/view" element={<NfcView />} />
            <Route path="/help" element={<HelpQuestions />} />
          </Routes>
        </div>

        {/* Footer */}
        <PoweredBy />
      </div>
    </TabProvider>
  );
}

export default App;
